/* Swirlume ROUGE — storefront runtime.
   Same behaviour as the Rouge artifact, but every cart operation goes through
   Shopify's Cart AJAX API instead of localStorage. */
(function () {
  'use strict';
  var S = window.SW_SHOP || {};
  var ROOT = (S.routes && S.routes.root_url) || '/';
  if (ROOT.slice(-1) !== '/') ROOT += '/';

  var money = function (c) { return '$' + (c % 100 ? (c / 100).toFixed(2) : String(c / 100)); };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var el = $('#toast'); if (!el) return;
    el.textContent = msg; el.classList.add('on');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { el.classList.remove('on'); }, 1900);
  }

  /* ---------- mobile menu ---------- */
  var lastFocus = null;
  function menu(open) {
    document.body.classList.toggle('menu', !!open);
    var b = $('.burger'); if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
    var m = $('#mnav'); if (m) m.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (open) { lastFocus = document.activeElement; var x = $('#mnav .x'); if (x) setTimeout(function () { x.focus(); }, 50); }
    else if (lastFocus && lastFocus.focus) { lastFocus.focus(); lastFocus = null; }
  }

  /* ---------- cart ---------- */
  var cart = {
    state: null,

    open: function () {
      if (document.body.classList.contains('cart')) { this.refresh(); return; } /* on /cart the page itself is the cart */
      document.body.classList.add('cart-open');
      var d = $('#drawer'); if (d) { d.setAttribute('aria-hidden', 'false'); this._last = document.activeElement; var c = $('.dh button', d); if (c) setTimeout(function () { c.focus(); }, 50); }
      this.refresh();
    },
    close: function () {
      document.body.classList.remove('cart-open');
      var d = $('#drawer'); if (d) d.setAttribute('aria-hidden', 'true');
      if (this._last && this._last.focus) { this._last.focus(); this._last = null; }
    },

    get: function () {
      var empty = { item_count: 0, total_price: 0, items: [] };
      return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : empty; })
        .catch(function () { return empty; });
    },

    refresh: function () {
      var self = this;
      return this.get().then(function (c) { self.state = c; self.render(c); return c; });
    },

    add: function (items, label) {
      var self = this;
      return fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json(); }).catch(function () { return { status: 1 }; }).then(function (res) {
        if (res.status) { toast(res.description || res.message || 'Could not add that'); return null; }
        toast(label || 'Added to cart');
        return self.refresh().then(function () { self.open(); return res; });
      });
    },

    change: function (key, qty) {
      var self = this;
      return fetch(ROOT + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function (c) {
        if (c.status) { toast(c.description || c.message || 'Could not update cart'); return self.refresh(); }
        /* change.js can return a stale total before automatic discounts settle: re-read the cart */
        if (document.body.classList.contains('cart')) { location.reload(); return c; } /* /cart page is server-rendered */
        return self.refresh();
      }).catch(function () { toast('Could not update cart'); return self.refresh(); });
    },

    render: function (c) {
      var n = c.item_count, total = c.total_price;

      $$('[data-cart-count]').forEach(function (e) { e.textContent = n; });
      $$('[data-cart-total]').forEach(function (e) { e.textContent = money(total); });
      var lbl = $('[data-cart-label]'); if (lbl) lbl.textContent = n ? n + (n > 1 ? ' items' : ' item') : '';

      var ship = $('[data-ship]');
      if (ship) {
        var free = S.freeShip || 5000, show = S.freeShow || free, left = total >= free ? 0 : Math.max(0, show - total);
        ship.innerHTML = left > 0
          ? money(left) + ' away from included US shipping<div class="bar"><i style="width:' + Math.min(100, total / show * 100) + '%"></i></div>'
          : 'US shipping included<div class="bar"><i style="width:100%"></i></div>';
      }

      var box = $('[data-items]');
      if (!box) return;
      if (!c.items.length) {
        box.innerHTML = '<p style="padding:48px 0;text-align:center;color:var(--mute);font-size:13px">Your cart is empty.<br><br>'
          + '<a class="btn sm" href="' + ROOT + 'collections/sour-challenge">Start with a flavor</a></p>';
        return;
      }
      box.innerHTML = c.items.map(function (it) {
        var group = (it.properties && (it.properties._Box || it.properties._Mix)) || '';
        var opts = (it.options_with_values || []).map(function (o) { return o.value; }).join(' · ');
        var img = it.featured_image && it.featured_image.url
          ? '<img src="' + it.featured_image.url + (it.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="" width="72" height="72" loading="lazy">' : '';
        return '<div class="ci">' + img + '<div>'
          + '<b>' + esc(group || it.product_title) + '</b>'
          + '<small>' + esc(group ? it.product_title + ' · ' + opts : opts) + (/Variety/.test(opts) ? '<span class="ltdb sm"><svg viewBox=\"0 0 24 24\" aria-hidden=\"true\"><path d=\"M12 2.5l2.6 6.2 6.7.5-5.1 4.4 1.6 6.5L12 16.6 6.2 20.1l1.6-6.5L2.7 9.2l6.7-.5z\"/></svg>Limited Edition</span>' : '') + (it.selling_plan_allocation ? ' · ' + esc(it.selling_plan_allocation.selling_plan.name) : '') + '</small>'
          + '<div class="q">'
          + '<button type="button" data-q="' + esc(it.key) + '" data-to="' + (it.quantity - 1) + '" aria-label="Less ' + esc(it.product_title) + '">&minus;</button>'
          + '<span>' + it.quantity + '</span>'
          + '<button type="button" data-q="' + esc(it.key) + '" data-to="' + (it.quantity + 1) + '" aria-label="More ' + esc(it.product_title) + '">+</button>'
          + '<button type="button" class="rm" data-q="' + esc(it.key) + '" data-to="0">Remove</button>'
          + '</div></div>'
          + '<span class="lp">' + (it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '') + money(it.final_line_price) + '</span>'
          + '</div>';
      }).join('');
    }
  };

  /* delegated controls: quantity + header/drawer actions (replaces inline onclick, which
     threw before this deferred script ran) */
  document.addEventListener('click', function (e) {
    /* cart quantity controls only: [data-q][data-to]. Build Your Box also uses data-q
       (flavor steppers, data-d) and must not reach cart/change.js ("Cannot find variant"). */
    var t = e.target.closest && e.target.closest('[data-q][data-to]');
    if (t) { e.preventDefault(); cart.change(t.getAttribute('data-q'), parseInt(t.getAttribute('data-to'), 10)); return; }
    var a = e.target.closest && e.target.closest('[data-act]');
    if (!a) return;
    var act = a.getAttribute('data-act');
    if (act === 'menu-open') { e.preventDefault(); menu(1); }
    else if (act === 'menu-close') { menu(0); }
    else if (act === 'cart-open') { e.preventDefault(); cart.open(); }
    else if (act === 'cart-close') { e.preventDefault(); cart.close(); }
  });

  /* esc closes overlays */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { cart.close(); menu(0); }
  });

  window.SW = { cart: cart, menu: menu, toast: toast, money: money, esc: esc, root: ROOT };

  /* paint the server-side count immediately; only hit /cart.js when there is a cart to show */
  document.addEventListener('DOMContentLoaded', function () {
    if (S.sellOpen && (S.cartCount > 0 || document.body.classList.contains('cart'))) cart.refresh();
    else cart.render({ item_count: S.cartCount || 0, total_price: S.cartTotal || 0, items: [] });
  });
})();
